var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar rounded m-0 w-100 position-relative",class:( _obj = {
    'bg-lighter': _vm.percentage === 0
  }, _obj[("progress-bar--" + _vm.backgroundType)] = _vm.percentage !== 0, _obj )},[(_vm.percentage > 0)?_c('div',{staticClass:"progress-bar__bar rounded",style:({ width: ((100 - _vm.percentage) + "%") })}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }